import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fRef } from '../../utils/React.js';
import { SpinnerPresentation } from '../Spinner/SpinnerPresentation.js';
import { mainClass } from './Action.styles.js';

var defaultProps = {
  hasTabIndex: true,
  onClick: function onClick() {
    /* empty */
  },
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  },
  onKeyboardFocusChange: function onKeyboardFocusChange() {
    /* empty */
  }
};
var ActionPresentation = fRef(function (props) {
  var _cleanupClassObject;

  var disabled = props.disabled,
      loading = props.loading,
      id = props.id,
      hasTabIndex = props.hasTabIndex,
      href = props.href,
      nonInteractive = props.nonInteractive,
      onClick = props.onClick,
      ref = props.ref,
      onKeyboardFocusChange = props.onKeyboardFocusChange,
      onMouseHoverChange = props.onMouseHoverChange,
      onMouseDown = props.onMouseDown,
      onKeyDown = props.onKeyDown,
      children = props.children,
      htmlAttrs = props.htmlAttrs,
      name = props.name,
      className = props.className,
      isDisplayInline = props.isDisplayInline,
      expandToOverlay = props.expandToOverlay;
  var classes = cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(mainClass), true), _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__inline"), isDisplayInline), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__loading"), loading), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__overlay"), expandToOverlay), _cleanupClassObject));

  if (nonInteractive) {
    return /*#__PURE__*/React.createElement("span", {
      className: classes,
      onMouseEnter: function onMouseEnter() {
        if (document.documentElement.getAttribute("data-whatintent") === "mouse") {
          onMouseHoverChange(true);
        }
      },
      onMouseLeave: function onMouseLeave() {
        return onMouseHoverChange(false);
      }
    }, children, loading && /*#__PURE__*/React.createElement("span", {
      className: "".concat(mainClass, "-spinner")
    }, /*#__PURE__*/React.createElement(SpinnerPresentation, {
      variant: "indeterminate",
      size: 24
    })));
  }

  var Component = href && "a" || isDisplayInline && "span" || "button"; // fixes https://stackoverflow.com/questions/4763638/enter-triggers-button-click
  // isDisplayInline (Links) must not have type "button" as the inline style/line break won't work - they are displayed as block

  var type = (htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.type) || !href && !isDisplayInline && "button" || undefined;
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, htmlAttrs, {
    className: classes,
    id: id,
    role: isDisplayInline && !href && "button" || undefined,
    onClick: !disabled && !loading && onClick ? function (e) {
      return onClick(e, name);
    } : undefined,
    onMouseEnter: function onMouseEnter() {
      if (document.documentElement.getAttribute("data-whatintent") === "mouse") {
        onMouseHoverChange(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      return onMouseHoverChange(false);
    },
    onFocus: function onFocus() {
      if (document.documentElement.getAttribute("data-whatinput") === "keyboard") {
        onKeyboardFocusChange(true);
      }
    },
    onMouseDown: onMouseDown,
    onKeyDown: onKeyDown,
    onBlur: function onBlur() {
      return onKeyboardFocusChange(false);
    },
    ref: ref,
    disabled: href ? undefined : disabled || loading,
    "aria-disabled": href && (disabled || loading) ? "true" : undefined,
    tabIndex: disabled || loading || !hasTabIndex ? -1 : 0,
    href: href && !disabled && !loading ? href : undefined,
    name: href ? undefined : name,
    type: type
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(mainClass, "-inner")
  }, children), loading && /*#__PURE__*/React.createElement("span", {
    className: "".concat(mainClass, "-spinner")
  }, /*#__PURE__*/React.createElement(SpinnerPresentation, {
    variant: "indeterminate",
    size: 24
  })));
}, defaultProps);

export { ActionPresentation, defaultProps };
